import { MenuItem, TextField } from "@mui/material";
import { Flex } from "@zfp-akademie-a-s/zfp-design";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { useSetAnalysisOrganizedBy } from "Infrastructure/ApiZfp/AnalyzerApi";
import { SetOrganizedByBodyOrganizedBy } from "Infrastructure/ApiZfp/Schema/setOrganizedByBodyOrganizedBy";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { useQuestionnaireContext } from "./QuestionnaireContext";

export const QuestionnaireOrganizedBy = () => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const { organizedBy, isReadOnly } = useQuestionnaireContext();

  const { mutate, isPending: isSaving } = useSetAnalysisOrganizedBy();

  const [value, setValue] = useState<string>(organizedBy);

  useEffect(() => {
    setValue(organizedBy);
  }, [organizedBy]);

  const options = useMemo(
    () => [
      { value: SetOrganizedByBodyOrganizedBy.client, label: t(Resources.Questionnaire.OrganizedByOptions.Client) },
      { value: SetOrganizedByBodyOrganizedBy.agent, label: t(Resources.Questionnaire.OrganizedByOptions.Agent) },
    ],
    [t],
  );

  const handleChange = (newValue: string | number | string[] | number[]) => {
    if (isSaving) return;
    const organizedBy = newValue as (typeof SetOrganizedByBodyOrganizedBy)[keyof typeof SetOrganizedByBodyOrganizedBy];
    const previous = value;
    setValue(organizedBy);
    mutate(
      { analysisId, versionId, data: { organizedBy } },
      {
        onError: () => {
          setValue(previous);
          toast.error(t(Resources.AnalysisDetail.Toast.ActionError));
        },
      },
    );
  };

  return (
    <Flex width="100%" maxWidth={400} py={Spacing.XXL}>
      <TextField
        select
        fullWidth
        label={t(Resources.Questionnaire.OrganizedByWho)}
        required
        value={value}
        onChange={(event) => handleChange(event.target.value)}
        disabled={isSaving || isReadOnly}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Flex>
  );
};
